/**
 * 业务管理重构 又一个屎山代码出现了
 * date:2022 03 30 fuck
 */
import httpRequest from '@/utils/request.js'

/** 获取监测点列表 */
export const carrierList = (params = {}, way) =>
  httpRequest.httpGet({
    url: '/service/carrier/list/' + way,
    params: {
      ...params
    }
  })
/** 获取监测点类型 */
export const carrierShareCarrierType = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/share/carrierType',
    params: {
      ...params
    }
  })
/** 获取监测点状态 */
export const carrierShareParam = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/share/param',
    params: {
      ...params
    }
  })
/** 监测点新增 */
export const carrierNew = (data, way) =>
  httpRequest.httpPost('/service/carrier/new/' + way, data)
/** 监测点编辑 */
export const carrierEdit = (data, way) =>
  httpRequest.httpPut('/service/carrier/edit/' + way, data)
/** 监测点删除 */
export const displayDelete = (data, way) =>
  httpRequest.httpdelete('/service/carrier/delete/' + way, data)
/** 获取监测点详细 */
export const carrierDetail = (type, id) =>
  httpRequest.httpGet({
    url: '/service/carrier/detail/' + type + '/' + id
  })

/** 关联监测点与设备 */
export const carrierRelated = (params = {}, way) =>
  httpRequest.httpGet({
    url: '/service/carrier/related/' + way,
    params: {
      ...params
    }
  })
/** 取消监测点关联设备 */
export const carrierRelease = (data, way) =>
  httpRequest.httpdelete('/service/carrier/release/' + way, data)
/** 关联监测点设备 */
export const carrierCarry = (data, way) =>
  httpRequest.httpPost(
    `/service/carrier/carry/${way}?devIds=${data.devIds}&devCatalog=${data.devCatalog}&carrierId=${data.carrierId}`
  )

/** 监测点获取采集点 */
export const carrierCollectBoot = (params = {}, way) =>
  httpRequest.httpGet({
    url: '/service/carrier/collect/boot/' + way,
    params: {
      ...params
    }
  })
/** 监测点获取默认采集点 */
export const carrierDefaultBoot = (params = {}, way) =>
  httpRequest.httpGet({
    url: '/service/carrier/collect/default/' + way,
    params: {
      ...params
    }
  })
/** 应用采集点数据 */
export const carrierApply = (data, way) =>
  httpRequest.httpPut(`/service/carrier/collect/apply/${way}`, data)
/** 关闭采集点数据 */
export const carrierClose = (data, way) =>
  httpRequest.httpdelete(`/service/carrier/collect/close/${way}`, data)
/** 获取监测区间 */
export const shareRange = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/share/range',
    params: {
      ...params
    }
  })
/** 获取计量单位 */
export const shareUnit = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/share/unit',
    params: {
      ...params
    }
  })
/** 获取转发平台 */
export const shareForward = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/share/forward',
    params: {
      ...params
    }
  })
/** 获取转发平台 */
export const carrierAssist = (params = {}, way) =>
  httpRequest.httpGet({
    url: '/service/carrier/assist/' + way,
    params: {
      ...params
    }
  })
/** 辅助信息应用 */
export const carrierAssistSet = (data, way) =>
  httpRequest.httpPut(`/service/carrierDevice/update/${way}`, data)
// 保存锚点
export const savePosition = (type, carrierId, carrierAnchors) =>
  httpRequest.httpPost(
    `/service/carrier/savePosition/${type}/${carrierId}`,
    carrierAnchors
  )
// 上传图片
export const uploadCarrierImg = (type, data) =>
  httpRequest.httpPost(`/service/carrier/uploadFile/${type}`, data)
// 保存监测点属性
export const saveProperty = (type, carrierTypeId, carrierId, data) =>
  httpRequest.httpPost(
    `/service/carrier/saveProperty/${type}/${carrierTypeId}/${carrierId}`,
    data
  )

// 监测点关联映射列表
export const carrierRelectList = (type, carrierId) =>
  httpRequest.httpGet({
    url: `/service/carrierDevice/list/${type}`,
    params: {
      carrierId
    }
  })

// 新增关联
export const addRelation = (type, data) =>
  httpRequest.httpPost(`/service/carrierDevice/add/${type}`, data)

// 修改关联
export const updateRelation = (type, data) =>
  httpRequest.httpPut(`/service/carrierDevice/update/${type}`, data)

// 删除关联
export const delRelation = (type, id) =>
  httpRequest.httpdelete(`/service/carrierDevice/delete/${type}?id=${id}`)

// 获取设备分页列表
export const getDevicePage = (type, params) =>
  httpRequest.httpGet({
    url: `/service/carrierDevice/device/list/${type}`,
    params
  })

// 编辑挂载报警开关
export const editAlarmSwitch = (type, params) =>
  httpRequest.httpPut(`/service/carrier/alarm/switch/${type}`, params)

// 监测点设备关联历史记录
export const probeHisotry = params =>
  httpRequest.httpGet({
    url: '/service/share/carrier/device/history',
    params
  })

// 监测点设备关联详细
export const probeDetail = (id, code, carrierType) =>
  httpRequest.httpGet({
    url: `/service/carrierDevice/get/${carrierType}`,
    params: {
      id,
      code
    }
  })
// 查询取样值历史
export const carrierHistory = params =>
  httpRequest.httpGet({
    url: '/service/share/carrier/sample/history',
    params
  })

// 获取底座分页列表
export const getBasePageList = (params, carrierType) =>
  httpRequest.httpGet({
    url: `/service/carrierDevice/plinth/list/${carrierType}`,
    params
  })

// 导出探头历史
export const exportProbeHistory = params =>
  httpRequest.httpPost('/service/share/export/carrier/device/history', params)

// 导出取样历史
export const exportSampleHisotry = params =>
  httpRequest.httpPost('/service/share/export/carrier/sample/history', params)

/**
 * 监测点详细数据详情
 * @param isDefault
 * @param carrierIdList
 * @returns {Promise | Promise<unknown>}
 */
export const carrierProbeList = (isDefault, carrierIdList) =>
  httpRequest.httpPost(
    `/service/detail/data/carrier/${isDefault}`,
    carrierIdList
  )

// 保存安装点
export const saveCarrierDevice = (type, params)  =>
  httpRequest.httpPost( `/service/carrierDevice/save/${type}`, params)

// 安装点开始切换
export const carrierChangeStart = (id)  =>
  httpRequest.httpGet({
    url:  `/service/carrierDevice/change/start/${id}`
  })
// 安装点终止切换
export const carrierChangeStop = (id)  =>
  httpRequest.httpGet({
    url: `/service/carrierDevice/change/stop/${id}`
  })
// 删除安装点切换历史（单个）
export const carrierDelHistory = (params)  =>
httpRequest.httpdelete( `/service/carrierDevice/change/his/delete`, params)
// 删除安装点切换历史（批量）
export const carrierDelHistoryBatch = (params)  =>
httpRequest.httpPost( `/service/carrierDevice/change/his/delete/batch`, params)
// 保存安装点通知
export const carrierNoticeSave = (type, params)   =>
httpRequest.httpPost( `/service/carrierDevice/notice/save/${type}`, params)
// 保存安装点通知(批量)
export const carrierNoticeSaveBatch = (type, params)   =>
httpRequest.httpPost( `/service/carrierDevice/notice/save/batch/${type}`, params)
// 获取安装点通知
export const getCarrierNotice = (type, id)  =>
  httpRequest.httpGet({
    url: `/service/carrierDevice/notice/get/${type}/${id}`,
  })

// 获取安装点切换历史
export const getCarrierHistory = (params)  =>
  httpRequest.httpGet({
    url: '/service/carrierDevice/change/his/page',
    params
  })
// 获取安装点信息
export const getCarrierInfo = (type, id)  =>
  httpRequest.httpGet({
    url: `/service/carrierDevice/get/${type}/${id}`,
  })
// 安装点终止切换
export const carrierChangeComplete = (id)  =>
  httpRequest.httpGet({
    url: `/service/carrierDevice/change/finish/${id}`
  })

// 获取自定义监测点列表
export const  getCustomMonitorList = ()  =>
  httpRequest.httpGet({
    url: `/service/carrier/monitor/scene/list`,
  })
// 保存自定义监测点列表
export const  saveCustomMonitor = (params)  =>
  httpRequest.httpPost( `/service/carrier/monitor/save/scene`, params)

// 删除自定义监测点列表
export const  deleteCustomMonitor = (params)  =>
  httpRequest.httpdelete( `/service/carrier/monitor/delete/scene`, params)

//获取架构监测点
export const  getSceneCarrierList = (params)  =>
  httpRequest.httpGet({
    url: `/service/carrier/monitor/getSceneCarrierList`,
    params
  })
// 获取所有选中的监测点列表
export const  getSceneCarrierSelectedList = ()  =>
  httpRequest.httpGet({
    url: `/service/carrier/monitor/selected/data`
  })

// 获取安装点图片信息
export const getCarrierDevicePicture = (params)  =>
  httpRequest.httpGet({
    url: `/service/carrierDevice/get/picture`,
    params
  })

// 保存安装点图片信息
export const saveCarrierDevicePicture = (params)  =>
  httpRequest.httpPost( `/service/carrierDevice/save/picture`, params)

// 删除安装点图片信息
export const  deleteCarrierDevicePicture = (id)  =>
  httpRequest.httpdelete( `/service/carrierDevice/delete/${id}/picture`)

// 上传安装点图片文件
export const uploadCarrierDevicePictureFile = data =>
  httpRequest.httpPost('/service/carrierDevice/upload/picture', data)
